import { useCallback, useEffect, useState } from 'react';
import { jsonAxios } from 'components/axios';
import MyPageTemplate from 'components/template/MyPageTemplate';
import Loading from 'components/common/Loading';
import { ISearchInfo } from 'types/as';
import Pagination from 'components/common/Pagination';
import CustomButton from 'components/common/CustomButton';
import { IInquiry } from 'types/inquiry';
import { useNavigate } from 'react-router-dom';
import InquiryDrawer from 'components/drawer/InquiryDrawer';

const InquiryList = () => {
    const navigate = useNavigate();
    const [loading, setLoading] = useState<boolean>(false);
    const [list, setList] = useState<IInquiry[]>([]);
    const [searchInfo, setSearchInfo] = useState<ISearchInfo>({
        page: 1,
    } as ISearchInfo)
    const [isOpen, setIsOpen] = useState<boolean>(false)
    const [select, setSelect] = useState<number>(0);
    const [totalPage, setTotalPage] = useState<number>(0)

    const tHeader = [
        { label: "No.", flex: 0.5 },
        { label: "날짜", flex: 0.5 },
        { label: "제목", flex: 1.0 },
        { label: "내용", flex: 1.0 },
        { label: "답변여부", flex: 0.5 },
    ];

    const init = useCallback(() => {
        setLoading(true)

        jsonAxios.get(`inquiry`).then(res => {
            console.log(res.data)
            if (res.data.code === 200) {
                setList(res.data.data)
                setTotalPage(res.data.totalPages || 0);
            }
        }).finally(() => {
            setTimeout(() => {
                setLoading(false)
            }, 400)
        })
    }, [searchInfo])

    useEffect(() => {
        init();
    }, [init])

    const toggleDrawer = () => {
        setIsOpen((p) => !p)
    }

    const titleStyle = () => {
        return `hidden tablet:block flex-[1.0] w-full bg-[#e5e5e5] py-1`
    }

    const tBodyStyle = () => {
        return `flex items-center justify-center py-2 text-center tablet:py-0 tablet:gap-2`
    }
    return (
        <MyPageTemplate background='bg-[#F8F8FA]'>
            <div className='flex flex-col gap-4 pt-10 tablet:pt-4 h-full min-h-dvh'>
                <div className='self-end'>
                    <CustomButton
                        title='문의등록'
                        className='bg-primary'
                        onClick={() => {
                            navigate('/mypage/inquiry/create')
                        }}
                    />
                </div>
                <div className='flex flex-col gap-3 bg-white hover:shadow-lg p-10 mobile:p-6 tablet:px-4 rounded-xl w-full transition-all'>
                    {
                        loading ?
                            <div className='flex justify-center items-center w-full'>
                                <Loading />
                            </div> :
                            <>
                                <div className='tablet:hidden flex bg-[#F8F8FA] font-semibold text-sm 2xl:text-base'>
                                    {
                                        tHeader.map((item, idx) => (
                                            <div
                                                key={idx}
                                                className={`flex-[${item.flex}] flex items-center justify-center h-15`}
                                            >
                                                {item.label}
                                            </div>
                                        ))
                                    }
                                </div>

                                {
                                    list.length > 0 ?
                                        <div className='flex flex-col gap-3 min-h-[30vh]'>
                                            {
                                                list.map((item, idx) => (
                                                    <div
                                                        className={`relative flex text-sm border border-[#E1E1E8] transition-all rounded tablet:flex-col tablet:gap-1 xl:h-20 cursor-pointer hover:bg-[#EEF4FF]`}
                                                        key={idx}
                                                        onClick={() => {
                                                            setIsOpen(true)
                                                            setSelect(item.id)
                                                        }}
                                                    >
                                                        {
                                                            item.hasUnconfirmed &&
                                                            <div className='top-2 left-2 absolute bg-red rounded-full w-2 h-2 font-semibold text-white text-xs'></div>
                                                        }

                                                        <div className={`flex-[0.5] ${tBodyStyle()} tablet:order-1`}>
                                                            <span className={titleStyle()}>{tHeader[0].label}</span>
                                                            <span className='flex-1'>
                                                                {10 * (searchInfo.page - 1) + idx + 1}
                                                            </span>
                                                        </div>
                                                        <div className={`flex-[0.5] ${tBodyStyle()} tablet:order-2`}>
                                                            <span className={titleStyle()}>{tHeader[1].label}</span>
                                                            <span className='flex-1'>
                                                                {item.createAt}
                                                            </span>
                                                        </div>
                                                        <div className={`flex-[1.0] min-w-0 ${tBodyStyle()} tablet:order-3`}>
                                                            <p className='truncate'>
                                                                {item.title}
                                                            </p>
                                                        </div>
                                                        <div className={`flex-[${tHeader[3].flex}] min-w-0 ${tBodyStyle()} tablet:order-3`}>
                                                            <span className={titleStyle()}>{tHeader[3].label}</span>
                                                            <p className='truncate'>
                                                                {item.content}
                                                            </p>
                                                        </div>
                                                        <div className={`flex-[${tHeader[4].flex}] min-w-0 ${tBodyStyle()} tablet:order-3`}>
                                                            <span className={titleStyle()}>{tHeader[4].label}</span>
                                                            <span className={item.isAnswered ? 'text-primary' : 'text-red'}>
                                                                {item.isAnswered ? '답변' : '미답변'}
                                                            </span>
                                                        </div>
                                                    </div>
                                                ))
                                            }
                                        </div>
                                        :
                                        <div className='flex justify-center items-center py-6 min-h-[30vh]'>
                                            데이터가 없습니다.
                                        </div>
                                }
                            </>
                    }
                </div>
                <Pagination
                    totalPage={totalPage}
                    currentPage={searchInfo.page}
                    onClick={(idx) => {
                        setSearchInfo(p => ({
                            ...p,
                            page: (idx + 1)
                        }))
                    }}
                />
            </div>

            <InquiryDrawer
                isOpen={isOpen}
                toggleDrawer={toggleDrawer}
                id={select}
                init={init}
            />

        </MyPageTemplate>
    )
}

export default InquiryList